import { createPinia } from 'pinia';
import Vue, { Component } from 'vue';

/**
 * Mount a single vue component to the given mount / selector.
 * ```
 * <div id="app-name" data-props="{}"></div>
 *
 * mountVueComponent(Component, { name: 'MyApp', mount: '#app-name' })
 * ```
 */
export function mountVueComponent(component: Component, { name, mount }: { name: string; mount: string }): Vue {
  const el: HTMLElement = document.querySelector(mount);

  if (!el) {
    return;
  }

  let props = {};

  if (el.dataset.props) {
    props = JSON.parse(el.dataset.props);
  }

  const pinia = createPinia();
  const app = new Vue({
    name,
    components: { App: component },
    render: (h) => h(component, { props }),
    pinia,
  });

  app.$mount(mount);

  return app;
}
